import script from "./EditClient.vue?vue&type=script&setup=true&lang=js"
export * from "./EditClient.vue?vue&type=script&setup=true&lang=js"

import "./EditClient.vue?vue&type=style&index=0&id=c2f7c552&lang=scss"

const __exports__ = script;

export default __exports__